//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const PreflightAllElementsShortCircuit: FeatureFlag = {"Id":"PreflightAllElementsShortCircuit","Label":"(KILL)[10.24]PreflightAllElementsShortCircuit","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. Check built-in all-element preflight rules before enumerating IPreflightAccess implementations.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":1};
